import { render, staticRenderFns } from "./competitor-matches.vue?vue&type=template&id=1b80155e&scoped=true"
import script from "./competitor-matches.vue?vue&type=script&lang=js"
export * from "./competitor-matches.vue?vue&type=script&lang=js"
import style0 from "./competitor-matches.vue?vue&type=style&index=0&id=1b80155e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b80155e",
  null
  
)

export default component.exports